import { CAST_PILOT_ASSISTANT } from '@cast/constants';

import { Typography, Box, tokens } from '@cast/design-system';

export const ErrorBubble = ({ error }: { error: string }) => {
  return (
    <Box
      sx={{
        p: 8,
        border: 'none',
        borderRadius: '8px',
        backgroundColor: tokens.theme.bg.structural.surface,
        maxWidth: '100%',
        minWidth: '100px',
        alignSelf: 'flex-start',
      }}
    >
      <Typography color={tokens.theme.fg.structural.secondary} variant="P10B">
        {CAST_PILOT_ASSISTANT}:
      </Typography>
      <Typography variant="P14R" color={tokens.theme.fg.status.error}>
        {error}
      </Typography>
    </Box>
  );
};
